import bart010 from 'bart010.png'

const Info = () => {

  window.location.replace( 'https://t.me/bart010_bot' )

  return <></>
}

export default Info
